<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">Beranda</a></li>
            <li class="breadcrumb-item"><a href="/pages/pemain">Pemain</a></li>
            <li class="breadcrumb-item active" aria-current="page">
              Tambah Pemain Baru
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-6 text-end">
        <router-link to="/pages/pemain">
          <b-button variant="danger" class="btn btn-add btn-sm mb-2 px-4">
            <i class="fa fa-arrow-left mr-1"></i> &nbsp; Kembali</b-button
          >
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Data Pemain</h6>
          </div>
          <hr />
          <div class="card-body">
            <form class="row g-3 needs-validation" novalidate="">
              <div class="col-md-4 position-relative">
                <label class="mb-1" for="validationTooltip03">Skuad Tim</label>
                <select
                  type="text"
                  class="form-control"
                  id="team_skuad_id"
                  v-model="form.team_skuad_id"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? formErorr.team_skuad_idError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                >
                  <option value="">- Pilih Skuad -</option>
                  <option
                    :value="list.id"
                    v-for="list in skuad_list"
                    :key="list.id"
                  >
                    {{ list.nama_skuad }}
                  </option>
                </select>
                <small
                  class="text-danger"
                  v-if="formErorr.team_skuad_idError && formSubmitted"
                >
                  {{ formErorr.team_skuad_idError }}
                </small>
              </div>

              <div class="col-md-4 position-relative">
                <label class="mb-1" for="validationTooltip02"
                  >Nama Pemain</label
                >
                <input
                  type="text"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? formErorr.namaError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                  id="nama"
                  placeholder="nama"
                  v-model="form.nama"
                />
                <small
                  class="align-end text-danger"
                  v-if="formErorr.namaError && formSubmitted"
                >
                  {{ formErorr.namaError }}
                </small>
              </div>

              <div class="col-md-4 position-relative">
                <label class="mb-1" for="validationTooltip02"
                  >Tempat Lahir</label
                >
                <input
                  type="text"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? formErorr.tempat_lahirError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                  id="tempat_lahir"
                  placeholder="tempat lahir"
                  v-model="form.tempat_lahir"
                />
                <small
                  class="align-end text-danger"
                  v-if="formErorr.tempat_lahirError && formSubmitted"
                >
                  {{ formErorr.tempat_lahirError }}
                </small>
              </div>

              <div class="col-md-2 position-relative">
                <label class="mb-1" for="validationTooltip01"
                  >Tanggal Lahir</label
                >
                <input
                  type="date"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? formErorr.tanggal_lahirError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                  id="tanggal_lahir"
                  placeholder="tanggal_lahir"
                  v-model="form.tanggal_lahir"
                />
                <small
                  class="align-end text-danger"
                  v-if="formErorr.tanggal_lahirError && formSubmitted"
                >
                  {{ formErorr.tanggal_lahirError }}
                </small>
              </div>

              <div class="col-md-2 position-relative">
                <label class="mb-1" for="validationTooltip11">Umur</label>
                <input
                  type="text"
                  class="form-control"
                  id="umur"
                  placeholder="umur"
                  v-model="form.umur"
                />
              </div>

              <div class="col-md-4 position-relative">
                <label class="mb-1" for="validationTooltip04">Posisi </label>
                <select
                  type="text"
                  class="form-control"
                  id="posisi"
                  v-model="form.posisi"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? formErorr.posisiError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                >
                  <option value="">- Pilih Posisi -</option>
                  <option
                    :value="list.id"
                    v-for="list in posisi_list"
                    :key="list.id"
                  >
                    {{ list.nama_posisi }}
                  </option>
                </select>
                <small
                  class="text-danger"
                  v-if="formErorr.posisiError && formSubmitted"
                >
                  {{ formErorr.posisiError }}
                </small>
              </div>

              <div class="col-md-4 position-relative">
                <label class="mb-1" for="validationTooltip11"
                  >No Punggung</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="no_punggung"
                  placeholder="no punggung"
                  v-model="form.no_punggung"
                />
              </div>

              <div class="col-md-12 position-relative">
                <label class="mb-1" for="validationTooltip11">Wali Murid</label>
                <input
                  type="text"
                  class="form-control"
                  id="wali_murid"
                  placeholder="wali murid"
                  v-model="form.wali_murid"
                />
              </div>

              <div class="col-md-12 position-relative">
                <label class="mb-1" for="validationTooltip11">Keterangan</label>
                <input
                  type="text"
                  class="form-control"
                  id="keterangan"
                  placeholder="Keterangan"
                  v-model="form.keterangan"
                />
              </div>

              <div class="col-md-4 position-relative">
                <label for="formFileSm" class="mb-1">Foto Pemain</label>
                <input
                  class="form-control form-control-sm"
                  id="formFileSm"
                  type="file"
                  @change="imageShow"
                  accept="image/*"
                  v-bind:class="
                    formSubmitted ? (!images ? 'is-invalid' : 'is-valid') : ''
                  "
                />
                <small class="text-danger" v-if="!images && formSubmitted">
                  images harus di isi !
                </small>
                <div>
                  <img
                    :src="previewUrl"
                    class="rounded mr-4 mt-4 w-20"
                    width="100"
                  />
                </div>
              </div>
              <div class="col-12 text-end">
                <button class="btn btn-light" @click="resetForm" type="button">
                  Reset
                </button>
                &nbsp;
                <button
                  class="btn btn-primary"
                  @click="simpanPemain"
                  type="button"
                >
                  <span v-if="loading">
                    <div
                      class="spinner-border spinner-border-sm"
                      role="tempat_lahir"
                    >
                      <span class="sr-only"></span>
                    </div>
                    Loading ..
                  </span>
                  <span v-else> Simpan </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import PemainService from "@/_services/pemain.service";
import SkuadService from "@/_services/skuad.service";
import PosisiService from "@/_services/posisi.service";
import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DropZone from "dropzone-vue";

export default {
  components: {
    ckeditor: CKEditor.component,
    DropZone,
  },
  data() {
    return {
      urlImage: process.env.VUE_APP_API_URL_IMAGE,
      loading: false,
      skuad_list: [],
      posisi_list: [],
      form: {
        team_skuad_id: "",
        nama: "",
        umur: "",
        tempat_lahir: "",
        tanggal_lahir: "",
        posisi: "",
        no_punggung: "",
        wali_murid: "",
        keterangan: "",
      },
      formErorr: {
        namaError: false,
        team_skuad_idError: false,
        posisiError: false,
        tempat_lahirError: false,
        tanggal_lahirError: false,
        tempat_lahirError: false,
      },
      images: "",
      previewUrl: null,
      imagesError: false,
      validation: false,
      errors: [],
      formSubmitted: false,
      editor: ClassicEditor,
    };
  },

  methods: {
    imageShow(evt) {
      this.images = evt.target.files[0];
      this.previewUrl = URL.createObjectURL(evt.target.files[0]);
    },

    validationForm() {
      this.errors = [];
      if (this.form.nama.length < 1) {
        this.formErorr.namaError = "nama harus di isi !";
      } else {
        this.formErorr.namaError = false;
      }

      if (this.form.team_skuad_id.length < 1) {
        this.formErorr.team_skuad_idError = "team skuad harus di isi !";
      } else {
        this.formErorr.team_skuad_idError = false;
      }

      if (this.form.tanggal_lahir.length < 1) {
        this.formErorr.tanggal_lahirError = "tanggal lahir harus di isi !";
      } else {
        this.formErorr.tanggal_lahirError = false;
      }

      if (this.form.tempat_lahir.length < 1) {
        this.formErorr.tempat_lahirError = "tempat lahir harus di isi !";
      } else {
        this.formErorr.tempat_lahirError = false;
      }

      if (this.form.posisi.length < 1) {
        this.formErorr.posisiError = "posisi harus di isi !";
      } else {
        this.formErorr.posisiError = false;
      }

      if (this.images.length < 1) {
        this.imagesError = true;
        this.errors.push({
          message: "foto lawan harus di isi !",
        });
      } else {
        this.imagesError = false;
        this.errors.push({
          message: "",
        });
      }
    },

    simpanPemain() {
      this.formSubmitted = true;
      this.validationForm();

      if (
        this.form.tanggal_lahir &&
        this.form.team_skuad_id &&
        this.images &&
        this.form.posisi &&
        this.form.nama
      ) {
        this.loading = true;
        this.validation = true;

        const formData = new FormData();
        formData.append("team_skuad_id", this.form.team_skuad_id);
        formData.append("nama", this.form.nama);
        formData.append("tempat_lahir", this.form.tempat_lahir);
        formData.append("tanggal_lahir", this.form.tanggal_lahir);
        formData.append("no_punggung", this.form.no_punggung);
        formData.append("umur", this.form.umur);
        formData.append("posisi", this.form.posisi);
        formData.append("statistik", this.form.statistik);
        formData.append("keterangan", this.form.keterangan);
        formData.append("img", this.images);

        console.log("fd", FormData);
        PemainService.add(formData)
          .then((response) => {
            console.log("berhasil", response.data);
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Data Berhasil Ditambah",
              showConfirmButton: false,
              timer: 1500,
            });
            this.loading = false;
            this.$router.push("/pages/pemain");
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Data Gagal Ditambah",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      } else {
        console.log("validation failed");
      }
    },

    listSkuad() {
      SkuadService.dropdown()
        .then((response) => {
          this.skuad_list = [];
          let data_tim = response.data.data;
          console.log("data", response.data.data);
          data_tim.forEach((val, index) => {
            const data = {
              id: val.id,
              nama_skuad: val.nama_skuad,
            };
            this.skuad_list.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    listPosisi() {
      PosisiService.dropdownPemain()
        .then((response) => {
          this.posisi_list = [];
          let list_data = response.data.data;
          console.log("data", response.data.data);
          list_data.forEach((val, index) => {
            const data = {
              id: val.id,
              nama_posisi: val.nama_posisi,
            };
            this.posisi_list.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    resetForm() {
      console.log("rseset ");
      this.loading = false;
      this.images = "";
      this.previewUrl = null;
      this.imagesError = false;
      this.errors = [];
      this.formSubmitted = false;
      this.validation = false;
      this.form = {
        team_skuad_id: "",
        nama: "",
        umur: "",
        tempat_lahir: "",
        tanggal_lahir: "",
        posisi: "",
        no_punggung: "",
        wali_murid: "",
        keterangan: "",
      };
      this.formErorr = {
        namaError: false,
        team_skuad_idError: false,
        posisiError: false,
        tempat_lahirError: false,
        tanggal_lahirError: false,
        tempat_lahirError: false,
      };
    },
  },
  mounted() {
    this.listSkuad();
    this.listPosisi();
  },
};
</script>

<style lang="scss">
@import "dropzone-vue/dist/dropzone-vue.common.css";
.customize-table {
  --easy-table-header-font-size: 14px;
  --easy-table-header-height: 40px;
  --easy-table-body-row-height: 40px;
  --easy-table-body-row-font-size: 14px;
}

.searchBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#searchQueryInput {
  width: 100%;
  height: 2.4rem;
  background: #f5f5f5;
  outline: none;
  border: none;
  border-radius: 1.625rem;
  padding: 0 3.5rem 0 1.5rem;
  font-size: 1rem;
}

#searchQuerySubmit {
  width: 3.5rem;
  height: 2.8rem;
  margin-left: -3.5rem;
  background: none;
  border: none;
  outline: none;
}

#searchQuerySubmit:hover {
  cursor: pointer;
}

.font-large-2 {
  font-size: 3rem !important;
}

.count {
  background: rgb(149, 2, 13);
  background: radial-gradient(
    circle,
    rgba(149, 2, 13, 1) 0%,
    rgba(216, 49, 61, 1) 100%
  );
}
</style>
